let goals = document.querySelector('.js-goals');

if(goals !== null) {
    if((goals.classList.contains('is-active') === false)) {
            goals.classList.add('is-active');
    }
}

